import React from 'react'
import Spark from '../assets/spark.svg'

const TermsOfService = () => {
    return (
        <div className='w-full px-[4%] sm:px-[6%] xl:px-[10%] 2xl:px-[12.6%] py-10 md:py-[100px]'>
            <div className='capitalize text-[clamp(1.8rem,4vw,2.5rem)] font-[600] leading-[clamp(2rem,5vw,3.125rem)]'>
                <span className='text-black'>Our </span>
                <span className='text-primary'>Terms </span>
            </div>
            <p className='text-start mt-7 text-[16px] text-secondary leading-[28px] font-medium'>
                Within the Privacy Policy, The operator of this Website ("Website"), Supreme Nutra Shop, will be referred to as "Company," "we," or "us."
                We are committed to permission-based marketing while safeguarding your privacy online. Please read this privacy policy ("Policy") to understand how your personal information will be treated when submitted on the Website. This Policy also applies to individuals who have agreed to receive email marketing from the Company through opt-in or opt-out registration on another Website.
            </p>
            <div className='mt-4 md:mt-10 text-start'>
                <div className='flex items-center gap-2'>
                    <img src={Spark} alt="Spark" />
                    <p className='text-[18px] font-semibold leading-6'>Visitor Tracking:</p>
                </div>
                <p className='text-[14px] text-secondary leading-[26px] ps-[28px] py-2'>
                    We track domain, host, and/or Internet Protocol (IP) addresses from visitors to our Website.
                </p>
            </div>
            <div className='mt-4 text-start'>
                <div className='flex items-center gap-2'>
                    <img src={Spark} alt="Spark" />
                    <p className='text-[18px] font-semibold leading-6'>Registration Information:</p>
                </div>
                <p className='text-[14px] text-secondary leading-[26px] ps-[28px] pt-2'>
                    Some personally identifiable information is gathered when you register in part or in full for one of our services or promotions.
                </p>
                <p className='text-[14px] text-secondary leading-[26px] ps-[28px] '>
                    Registration is required to participate in promotions or sweepstakes on the Website.
                </p>
            </div>
            <div className='mt-4 text-start'>
                <div className='flex items-center gap-2'>
                    <img src={Spark} alt="Spark" />
                    <p className='text-[18px] font-semibold leading-6'>Co-Registration:</p>
                </div>
                <p className='text-[14px] text-secondary leading-[26px] ps-[28px] pt-2'>
                    In some cases, we may allow simultaneous registration (co-registration) with another third-party Website and our Website to participate in certain services or promotions.
                </p>
            </div>
            <div className='mt-4 text-start'>
                <div className='flex items-center gap-2'>
                    <img src={Spark} alt="Spark" />
                    <p className='text-[18px] font-semibold leading-6'>Problem Reporting:</p>
                </div>
                <p className='text-[14px] text-secondary leading-[26px] ps-[28px] pt-2'>
                    We may ask for personally identifiable information when you report a problem with the Website.
                </p>
                <p className='text-[14px] text-secondary leading-[26px] ps-[28px] '>
                    If you contact us, we may keep a record of the correspondence.
                </p>
            </div>
            <div className='mt-4 text-start'>
                <div className='flex items-center gap-2'>
                    <img src={Spark} alt="Spark" />
                    <p className='text-[18px] font-semibold leading-6'>Surveys and Research:</p>
                </div>
                <p className='text-[14px] text-secondary leading-[26px] ps-[28px] pt-2'>
                    From time to time, we may ask users to complete surveys for research or other purposes.
                </p>
            </div>
            <div className='mt-4 text-start'>
                <div className='flex items-center gap-2'>
                    <img src={Spark} alt="Spark" />
                    <p className='text-[18px] font-semibold leading-6'>Additional Resources and Services:</p>
                </div>
                <p className='text-[14px] text-secondary leading-[26px] ps-[28px] pt-2'>
                    We may offer resources, services, forms, or tools from which we may also collect your personal information.
                </p>
            </div>
        </div>
    )
}

export default TermsOfService